export default class ErrorHelper {
  private constructor() {}

  public static isConnectionLostError(error: any) {
    return (
      (error.constructor != null &&
        error.constructor.name === 'TimeoutError') ||
      error.status === 0
    );
  }

  public static evaluateError(
    error: VerificationError,
    message: string,
    precedence: number
  ): void {
    if (error.precedence == null || error.precedence > precedence) {
      error.message = message;
      error.precedence = precedence;
    }
  }
}

export interface VerificationError {
  precedence?: number;
  message?: string;
}
